import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { EtapasBeneficioComponent } from '../../shared/components/etapas-beneficio/etapas-beneficio.component';
import { BeneficiaryService } from '../../core/services/beneficiary.service';
import { SessionService } from '../../core/services/session.service';

@Component({
  standalone: true,
  selector: 'app-dados-funcionais',
  templateUrl: './dados-funcionais.component.html',
  styleUrls: ['./dados-funcionais.component.scss'],
  imports: [
    CommonModule,
    MatCardModule,
    EtapasBeneficioComponent
  ]
})
export class DadosFuncionaisComponent implements OnInit {
  beneficiario: any= '';

  beneficiarioPagina: any= '';

  constructor(private beneficiarioService: BeneficiaryService, private sessionService: SessionService) {}

  ngOnInit(): void {
    this.beneficiario = this.sessionService.beneficiario;
    this.beneficiarioService.getDadosFuncionais(this.beneficiario.matricula,this.beneficiario.orgao.id).subscribe({
      next: (res: any) => {
        console.log(res)
        this.beneficiarioPagina = res
      },
      error: (err: any) => {
        console.error('Erro ao enviar', err)
      }
    })
  }
}
